import React from 'react';
import Icon from 'components/Icon';
import BaseComponent from 'components/BaseComponent';
import { Modal } from 'antd';
import { Video } from 'components/Material';
import { getShowPreviewObj } from '@/routes/Material/Util/components/materialUtil';
import 'components/Modal/modal.less';

/** 在线预览视频组件 */
export class VideoPreviewComponent extends BaseComponent {

    state = {
        checkObj: this.props.checkObj,
    }

    componentWillReceiveProps(nextProps) {
        let { visible, checkObj } = nextProps;
        if (visible) {
            let divObj = this.refs.videoPreview;
            if (divObj) {
                let videoObj = divObj.firstChild;
                if (videoObj.paused) {
                    videoObj.currentTime = 0;
                    videoObj.play();
                }
            }
            this.setState({
                checkObj,
            });
        }
    }

    /** 关闭模态窗的同时,将视频停止播放 */
    onCloseVideoPreview = (e) => {
        if(e) {
            e.preventDefault;
            e.stopPropagation;
        }
        let divObj = this.refs.videoPreview;
        if (!divObj) {
            return;
        }
        let videoObj = divObj.firstChild;
        if (!videoObj.paused) {
            videoObj.pause();
        }
        this.setState({
            videoStatus: '0',
        });
        this.props.hidePreviewHandler();
    }

    /** 
     * 查看下一张或者前一张
     * 0:前一张 1: 下一张
     */
    onNextPreMaterial = (nextPre) => {
        let { previewRows } = this.props;
        let checkObj = this.state.checkObj;
        let showPreviewObj = getShowPreviewObj(nextPre, previewRows, checkObj);
        if (!showPreviewObj || !showPreviewObj.id) {
            return;
        }
        this.setState({
            checkObj: showPreviewObj,
        });
    }

    render() {
        const { title, visible, previewRows } = this.props;
        let { checkObj } = this.state;
        if (!checkObj || !checkObj.id) {
            return null;
        }
        let isNextPre = true;
        if (!previewRows || previewRows.length <= 1) {
            isNextPre = false;
        }
        let src = checkObj.path || checkObj.sourcepath;
        if (!src) {
            return null;
        }
        let index = src.indexOf(".");
        let poster = "";
        if (index !== "-1") {
            poster = src.substring(0, index) + ".jpg";
        }
        let newTitle = title;
        if (checkObj.name && checkObj.suffix) {
            newTitle = title + " - " + checkObj.name + "." + checkObj.suffix;
        }
        return (
            <Modal
                title={newTitle}
                visible={visible}
                width={930}
                maskClosable={false}
                onCancel={this.onCloseVideoPreview}
                footer={null}
                className="original-preview-model show-modal-head"
            >
                {isNextPre ? (
                    <div className="original-left">
                        <Icon className="left-arrow-o" onClick={(e) => { this.onNextPreMaterial(0) }} />
                    </div>
                ) : null }
                {isNextPre ? (
                    <div className="original-right">
                        <Icon className="right-arrow-o" onClick={(e) => { this.onNextPreMaterial(1) }} />
                    </div>
                ) : null }
                <div className="original-preview">
                    <div className="original-preview-body" ref="videoPreview">
                        <Video width="100%" height="100%" poster={poster} controls={"controls"} controlsList="nodownload" autoPlay="autoPlay" preload="auto" src={src} />
                    </div>
                </div>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/videoPreviewComponent.js